"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function animationFrameInterval(callback) {
    let cancelled = false;
    const callCallback = () => {
        if (cancelled)
            return;
        try {
            callback();
        }
        finally {
            window.requestAnimationFrame(callCallback);
        }
    };
    window.requestAnimationFrame(callCallback);
    return () => {
        cancelled = true;
    };
}
exports.default = animationFrameInterval;
